export default {
  SET_SUGGESTED_LOCATIONS(state, locations) {
    state.suggestedLocations = locations;
  },
  SET_SEARCH_LOCATIONS(state, locations) {
    state.searchLocations = locations;
  }
};
